export const environment = {
  apiUrl: 'api.medullar.dev',
  aiAPIUrl: 'https://api.medullar.dev/ai/v1',
  authAPIUrl: 'https://api.medullar.dev/auth/v1',
  environment_name: 'development',
  exploratorAPIUrl: 'https://api.medullar.dev/explorator/v1',
  production: true,
  registerKey: 'bWVkdWxsYXItcHVibGljOkxrckI9NVJfODskSyEsdlpoJT5GLg==',
  searchQueryEncryptionKey: 'xsyH85vzcnAEdG3Rr62MUkbhpumQD9CNtaT7KXeJWBgwSFY4VP',
  sentryDsn: 'https://2f9f08bc1faadab0ca535c2c99bcfddb@o4508602358890496.ingest.us.sentry.io/4508602362888192',
  showPurchaseButton: true,
  subscriptionKey: 'a07bfa1f0bcb406292d516ee0bb4cc57',
  turnstileSiteKey: '0x4AAAAAACA4SggnhS34BcV-',
};
